import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAppContext } from "../utils/context/app-context";
import { TextInput } from "../components/FormComponents";
import { AlertMessage } from "../components/UiComponents";
import useDocumentTitle from "../components/useDocumentTitle";

function ResetPassword() {
	useDocumentTitle("Reset Password");
	let { api } = useAppContext();

	const [email, setEmail] = useState("");
	const [code, setCode] = useState("");
	const [password, setPassword] = useState("");
	const [formErrors, setFormErrors] = useState({});
	const [submissionError, setSubmissionError] = useState(null);
	const [submitting, setSubmitting] = useState(false);
	const [submitted, setSubmitted] = useState(false);

	function handleEmailChange(e) {
		setEmail(e.target.value);
	}

	function handleCodeChange(e) {
		setCode(e.target.value);
	}

	function handlePasswordChange(e) {
		setPassword(e.target.value);
	}

	async function handleSubmit(e) {
		e.preventDefault();
		setSubmissionError(null);
		setSubmitted(false);
		let errors = {};

		if (!email) {
			errors.email = "Email is required";
		}

		if (!code) {
			errors.code = "Code is required";
		}

		if (!password) {
			errors.password = "Password is required";
		}

		// Password must be at least 8 characters long and contain at least one number and one letter
		if (
			password.length < 8 ||
			!password.match(/[a-z]/i) ||
			!password.match(/[0-9]/)
		) {
			errors.password =
				"Password must be at least 8 characters long and contain at least one number and one letter";
		}

		setFormErrors(errors);

		if (Object.keys(errors).length) {
			return;
		}
		setSubmitting(true);

		const { data, error } = await api.fetchData(
			"/reset-password",
			"POST",
			{ email, code, password }
		);

		if (data?.success) {
			setSubmitted(true);
		} else {
			setSubmissionError(data?.error || error || "An error occurred");
		}
		setSubmitting(false);
	}

	return (
		<div>
			{submitted ? (
				<>
				<div className="mb-3">
				<AlertMessage
					type="success"
					message="Your password has been changed"
				/>
				</div>
					<Link className="btn btn-tertiary" to="/login">Click Here to Login</Link>
				</>
			) : (
				<>
					<p className="auth-info-container__welcome">
						A reset code has been emailed to you, please enter the details
						below to change your password.
					</p>
					<form>
						<TextInput
							label={"Enter Reset Code"}
							name="code"
							type="code"
							value={code}
							onChange={handleCodeChange}
							required={true}
							error={formErrors?.code}
						/>
						<TextInput
							label={"Email"}
							name="email"
							type="email"
							value={email}
							onChange={handleEmailChange}
							required={true}
							error={formErrors?.email}
						/>
						<TextInput
							label="Password"
							name="password"
							type="password"
							value={password}
							onChange={handlePasswordChange}
							required={true}
							error={formErrors?.password}
						/>
						{submissionError && (
							<div className="alert-banner alert-banner__danger">
								{submissionError}
							</div>
						)}
						<div className="auth-info-container__login-bottom">
							<button
								type="submit"
								className="btn btn-tertiary auth-info-container__button"
								onClick={handleSubmit}
								disabled={submitting}>
								{submitting ? "Submitting..." : "Change Password"}
							</button>
							<p className="auth-info-container__small-link">
								<Link to="/login">Go To Login</Link>
							</p>
						</div>
					</form>
				</>
			)}
		</div>
	);
}

export default ResetPassword;
